import { MessageCircle } from "lucide-react";

export default function WhatsAppFAB() {
  return (
    <a
      data-testid="whatsapp-fab"
      href="https://wa.me/917016975324?text=Hello%20Sahyog%20Finance%2C%20I%27d%20like%20to%20know%20more."
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-20 right-5 md:bottom-20 md:right-7 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 group-hover:opacity-60 blur-md animate-pulse" />
      <span className="relative w-14 h-14 rounded-full grid place-items-center bg-[#25D366] text-white shadow-lg shadow-[#25D366]/40 hover:scale-105 transition-transform">
        <MessageCircle size={24} strokeWidth={2} />
      </span>
    </a>
  );
}
